import { render, staticRenderFns } from "./index-enterprise.vue?vue&type=template&id=5631d084&"
import script from "./index-enterprise.vue?vue&type=script&lang=js&"
export * from "./index-enterprise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports